/* eslint-disable camelcase */
import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { array, object, string } from "prop-types";
import CollectionTitle from "../../atoms/CollectionTitle";
import { RowSeparator } from "../../atoms/RowSeparator";
import { isCollectionEmpty } from "../../utils/collection";
import { useDeviceType } from "../../custom-hooks/useDeviceType";
import { DfpComponent } from "../../ads/dfp-component";
import { FirstColumn } from "./FirstColumn";
import { SecondColumn } from "./SecondColumn";
import { ThirdColumn } from "./ThirdColumn";

import "./three-col-nine-stories-var-one-with-bg.m.css";

export const ThreeColNineStoriesVarOneWithBG = ({ collection, stories, extraProp = "" }) => {
  const {
    row_background_color,
    text_color,
    show_timestamp,
    show_read_time,
    show_row_title,
    show_column_separator,
    show_story_separator,
    show_row_separator,
    enable_thumbnail_view,
    enable_row_ad,
    row_ad_details,
    show_row_ad_unit_bottom,
  } = get(collection, ["associated-metadata"], {});

  const filteredCollection = get(collection, ["items"], [])
    .slice(0, 3)
    .map((collections) => {
      return collections.type === "collection" ? collections : [];
    });
  const [firstCollection = {}, secondCollection = {}] = filteredCollection.slice(0, 2).map((collection) => {
    const isStoriesCollection = get(collection, ["items"], []).every((item) => item.type === "story");
    return isStoriesCollection ? collection : {};
  });
  const rowAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "row_ad_story_300x250"], {})
  );
  const bottomAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "row_bottom_ad"], {})
  );

  const rowAd = row_ad_details?.split("/").slice(-1)[0];
  const rowAdDivId = useSelector((state) => get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAd], ""));

  const rowAdBottom = show_row_ad_unit_bottom?.split("/").slice(-1)[0];
  const rowAdBottomDivId = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAdBottom], "")
  );

  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));
  const sectionSlug = extraProp;

  if (isCollectionEmpty(firstCollection) && isCollectionEmpty(secondCollection)) {
    return null;
  }
  const deviceType = useDeviceType();
  return (
    <div className="row-component">
      <div
        style={{
          backgroundColor: row_background_color,
          paddingTop: row_background_color ? "15px" : "none",
        }}
      >
        <div
          styleName="collections-container"
          style={{
            color: text_color,
          }}
        >
          <div styleName="columns">
            <div
              styleName="first-collection"
              style={{
                border:
                  (!isCollectionEmpty(secondCollection) &&
                    ((deviceType === "desktop" && show_column_separator) ||
                      (deviceType !== "desktop" && show_story_separator))) ||
                  "none",
              }}
            >
              {show_row_title && (
                <CollectionTitle
                  collection={firstCollection}
                  containerStyles={"row-title"}
                  enableSponsorAd={false}
                  sponsorAdDetails={""}
                  sponsorAdConfig={""}
                  sectionSlug={sectionSlug}
                />
              )}
              {!isCollectionEmpty(firstCollection) && (
                <div styleName="first-collection-columns">
                  <FirstColumn
                    story={firstCollection?.items[0].story}
                    show_column_separator={show_column_separator}
                    show_story_separator={show_story_separator}
                    show_timestamp={show_timestamp}
                    show_read_time={show_read_time}
                    sectionSlug={sectionSlug}
                  />
                  <SecondColumn
                    stories={firstCollection?.items.slice(1, 5)}
                    show_column_separator={show_column_separator}
                    show_story_separator={show_story_separator}
                    show_timestamp={show_timestamp}
                    show_read_time={show_read_time}
                    sectionSlug={sectionSlug}
                  />
                </div>
              )}
            </div>
            <div styleName="second-collection">
              {enable_row_ad ? (
                <DfpComponent
                  adStyleName="three-col-nine-var-one-withbg-ad-slot-size-300x250"
                  id={rowAdDivId}
                  containerStyle={"ad-margin"}
                />
              ) : (
                <ThirdColumn
                  collection={secondCollection}
                  show_story_separator={show_story_separator}
                  show_column_separator={show_column_separator}
                  show_timestamp={show_timestamp}
                  show_read_time={show_read_time}
                  show_row_title={show_row_title}
                  enable_thumbnail_view={enable_thumbnail_view}
                  sectionSlug={sectionSlug}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {show_row_separator && <RowSeparator />}
      {show_row_ad_unit_bottom && <DfpComponent adStyleName="ad-slot-size-300x250" id={rowAdBottomDivId} />}
    </div>
  );
};

ThreeColNineStoriesVarOneWithBG.propTypes = {
  collection: object,
  stories: array,
  extraProp: string,
};

ThreeColNineStoriesVarOneWithBG.storyLimit = 9;
